// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TwofactorPage – styles moved from inline (twofactor_outer_s + modals) */

/* Security level label (High / Medium / Low) */
.twofactor_outer_s .tf-security-level {
  font-weight: bold;
}
.twofactor_outer_s .tf-security-level--high {
  color: #28a745;
}
.twofactor_outer_s .tf-security-level--medium {
  color: #1e56f5;
}
.twofactor_outer_s .tf-security-level--low {
  color: #dc3545;
}

.twofactor_outer_s .tf-methods-count {
  margin-left: 15px;
  color: #888;
}

.twofactor_outer_s .tf-factor-hint {
  color: #888;
  font-size: 12px;
}

.twofactor-page .tf-icon-inline-sm {
  font-size: 20px;
  margin-right: 8px;
}

/* Google Auth QR step */
.twofactor-page .tf-qr-box {
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  display: inline-block;
}
.twofactor-page .tf-qr-box .tf-qr-img {
  max-width: 200px;
}

.twofactor-page .tf-mt-15 {
  margin-top: 15px;
}
.twofactor-page .tf-mb-10 {
  margin-bottom: 10px;
}
.twofactor-page .tf-mb-20 {
  margin-bottom: 20px;
}
.twofactor-page .tf-text-center {
  text-align: center;
}

/* Passkey verify circle (subtle, modal) */
.twofactor-page .tf-passkey-circle-subtle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}
.twofactor-page .tf-passkey-circle-subtle .tf-fingerprint-40 {
  font-size: 40px;
  color: #fff;
}

.twofactor-page .tf-emailinput-mt {
  margin-top: 15px;
}
.twofactor-page .tf-link-row-mt {
  margin-top: 15px;
}

.twofactor-page .tf-blocking-lead {
  margin-top: 15px;
}
.twofactor-page .tf-blocking-sub {
  color: #888;
  margin-top: 10px;
}

/* Add passkey modal – uses global verify_authenticator_icon_circle--success --lg for green circle */

.twofactor-page .tf-passkey-intro {
  margin-bottom: 10px;
}
.twofactor-page .tf-passkey-benefits {
  font-size: 13px;
  color: #888;
  margin-bottom: 20px;
}

.twofactor-page .tf-modal-title-icon {
  margin-right: 8px;
}
.twofactor-page .tf-modal-title-icon-key {
  margin-right: 8px;
}

.twofactor-page .tf-passkey-item {
  padding: 12px 15px;
  background: #2f3542;
  border-radius: 8px;
  margin-bottom: 10px;
}
.twofactor-page .tf-passkey-item-icon {
  font-size: 18px;
  margin-right: 10px;
  color: #00c853;
}
.twofactor-page .tf-passkey-item-name {
  color: #fff;
}
.twofactor-page .tf-passkey-item-meta {
  font-size: 11px;
  color: #888;
}
.twofactor-page .tf-passkey-item-meta-dim {
  font-size: 11px;
  color: #666;
}

.twofactor-page .tf-btn-remove-passkey {
  background: #dc3545;
  color: #fff;
  padding: 5px 12px;
  border-radius: 5px;
  border: none;
}

.twofactor-page .tf-passkeys-empty {
  padding: 30px;
  color: #888;
}
.twofactor-page .tf-passkeys-empty-icon {
  font-size: 48px;
  margin-bottom: 15px;
  display: block;
}

.twofactor-page .tf-btn-mt-15 {
  margin-top: 15px;
}
.twofactor-page .tf-btn-mt-10 {
  margin-top: 10px;
}
.twofactor-page .tf-icon-add-mr {
  margin-right: 5px;
}

/* Consent / security notice modals */
.twofactor-page .tf-modal-icon-warning {
  color: #1e56f5;
  margin-right: 8px;
}
.twofactor-page .tf-modal-icon-danger {
  color: #dc3545;
  margin-right: 8px;
}

.twofactor-page .tf-consent-body {
  margin-bottom: 20px;
}
.twofactor-page .tf-consent-p {
  color: #fff;
  margin-bottom: 15px;
  font-size: 14px;
}
.twofactor-page .tf-consent-body p:last-child {
  margin-bottom: 0;
}
.twofactor-page .tf-consent-icon-info {
  color: #ffc107;
  margin-right: 8px;
}
.twofactor-page .tf-consent-icon-time {
  color: #ffc107;
  margin-right: 8px;
}
.twofactor-page .tf-consent-icon-info-danger {
  color: #dc3545;
  margin-right: 8px;
}
.twofactor-page .tf-consent-icon-shield {
  color: #28a745;
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/twofactor.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E,+CAA+C;AAC/C;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,oGAAoG;;AAEpG;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* TwofactorPage – styles moved from inline (twofactor_outer_s + modals) */\n\n/* Security level label (High / Medium / Low) */\n.twofactor_outer_s .tf-security-level {\n  font-weight: bold;\n}\n.twofactor_outer_s .tf-security-level--high {\n  color: #28a745;\n}\n.twofactor_outer_s .tf-security-level--medium {\n  color: #1e56f5;\n}\n.twofactor_outer_s .tf-security-level--low {\n  color: #dc3545;\n}\n\n.twofactor_outer_s .tf-methods-count {\n  margin-left: 15px;\n  color: #888;\n}\n\n.twofactor_outer_s .tf-factor-hint {\n  color: #888;\n  font-size: 12px;\n}\n\n.twofactor-page .tf-icon-inline-sm {\n  font-size: 20px;\n  margin-right: 8px;\n}\n\n/* Google Auth QR step */\n.twofactor-page .tf-qr-box {\n  padding: 20px;\n  background: #fff;\n  border-radius: 10px;\n  display: inline-block;\n}\n.twofactor-page .tf-qr-box .tf-qr-img {\n  max-width: 200px;\n}\n\n.twofactor-page .tf-mt-15 {\n  margin-top: 15px;\n}\n.twofactor-page .tf-mb-10 {\n  margin-bottom: 10px;\n}\n.twofactor-page .tf-mb-20 {\n  margin-bottom: 20px;\n}\n.twofactor-page .tf-text-center {\n  text-align: center;\n}\n\n/* Passkey verify circle (subtle, modal) */\n.twofactor-page .tf-passkey-circle-subtle {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n}\n.twofactor-page .tf-passkey-circle-subtle .tf-fingerprint-40 {\n  font-size: 40px;\n  color: #fff;\n}\n\n.twofactor-page .tf-emailinput-mt {\n  margin-top: 15px;\n}\n.twofactor-page .tf-link-row-mt {\n  margin-top: 15px;\n}\n\n.twofactor-page .tf-blocking-lead {\n  margin-top: 15px;\n}\n.twofactor-page .tf-blocking-sub {\n  color: #888;\n  margin-top: 10px;\n}\n\n/* Add passkey modal – uses global verify_authenticator_icon_circle--success --lg for green circle */\n\n.twofactor-page .tf-passkey-intro {\n  margin-bottom: 10px;\n}\n.twofactor-page .tf-passkey-benefits {\n  font-size: 13px;\n  color: #888;\n  margin-bottom: 20px;\n}\n\n.twofactor-page .tf-modal-title-icon {\n  margin-right: 8px;\n}\n.twofactor-page .tf-modal-title-icon-key {\n  margin-right: 8px;\n}\n\n.twofactor-page .tf-passkey-item {\n  padding: 12px 15px;\n  background: #2f3542;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n.twofactor-page .tf-passkey-item-icon {\n  font-size: 18px;\n  margin-right: 10px;\n  color: #00c853;\n}\n.twofactor-page .tf-passkey-item-name {\n  color: #fff;\n}\n.twofactor-page .tf-passkey-item-meta {\n  font-size: 11px;\n  color: #888;\n}\n.twofactor-page .tf-passkey-item-meta-dim {\n  font-size: 11px;\n  color: #666;\n}\n\n.twofactor-page .tf-btn-remove-passkey {\n  background: #dc3545;\n  color: #fff;\n  padding: 5px 12px;\n  border-radius: 5px;\n  border: none;\n}\n\n.twofactor-page .tf-passkeys-empty {\n  padding: 30px;\n  color: #888;\n}\n.twofactor-page .tf-passkeys-empty-icon {\n  font-size: 48px;\n  margin-bottom: 15px;\n  display: block;\n}\n\n.twofactor-page .tf-btn-mt-15 {\n  margin-top: 15px;\n}\n.twofactor-page .tf-btn-mt-10 {\n  margin-top: 10px;\n}\n.twofactor-page .tf-icon-add-mr {\n  margin-right: 5px;\n}\n\n/* Consent / security notice modals */\n.twofactor-page .tf-modal-icon-warning {\n  color: #1e56f5;\n  margin-right: 8px;\n}\n.twofactor-page .tf-modal-icon-danger {\n  color: #dc3545;\n  margin-right: 8px;\n}\n\n.twofactor-page .tf-consent-body {\n  margin-bottom: 20px;\n}\n.twofactor-page .tf-consent-p {\n  color: #fff;\n  margin-bottom: 15px;\n  font-size: 14px;\n}\n.twofactor-page .tf-consent-body p:last-child {\n  margin-bottom: 0;\n}\n.twofactor-page .tf-consent-icon-info {\n  color: #ffc107;\n  margin-right: 8px;\n}\n.twofactor-page .tf-consent-icon-time {\n  color: #ffc107;\n  margin-right: 8px;\n}\n.twofactor-page .tf-consent-icon-info-danger {\n  color: #dc3545;\n  margin-right: 8px;\n}\n.twofactor-page .tf-consent-icon-shield {\n  color: #28a745;\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
